import { render, staticRenderFns } from "./VArchive.vue?vue&type=template&id=47792429&"
import script from "./VArchive.vue?vue&type=script&lang=js&"
export * from "./VArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports